import { FlowV2_Action__Input } from '~/graphql/types';
import { ClientFlowActionContactDetails } from '~/graphql/types.client';
import removeTypenames from '~/util/removeTypenames';
import getActiveField from '~/components/page/Automation/v2/components/UpdateAction/components/ContactDetails/utils/getActiveField';
import serializeStringInput from '~/components/organism/TemplateStringInput/utils/serializeStringInput';
import { assertNever } from '~/util/assertion';

/**
 *
 * @param {ClientFlowActionContactDetails} action - ContactDetails client action
 */
const serializeContactDetailsAction = (
  action: ClientFlowActionContactDetails,
): FlowV2_Action__Input => {
  const { id, accountId, flowBlueprintId, parentIds, field } = action;

  const activeField = getActiveField(action);
  const fieldValue = (() => {
    switch (activeField) {
      case 'name':
        return field.name ? { name: serializeStringInput(field.name) } : {};

      case 'phone':
        return field.phone ? { phone: serializeStringInput(field.phone) } : {};

      case 'unsubscribeEmail':
        return { unsubscribeEmail: field.unsubscribeEmail };

      default:
        return assertNever(activeField);
    }
  })();

  return {
    Contact: {
      Details: {
        id,
        accountId,
        flowBlueprintId,
        parentIds,
        field: removeTypenames(fieldValue),
      },
    },
  };
};
export default serializeContactDetailsAction;
